export const groupData = [
  {
    path: "/apply/GoodsGroup/4/index",
    name: "首页"
  },
  {
    path: "/apply/GoodsGroup/4/shopList",
    name: "店铺列表"
  },
  //{
  // path: "/apply/GoodsGroup/4/GroupManage",
  //  name: "团购管理"
  // },
  {
    path: "/apply/GoodsGroup/4/groupProduct",
    name: "团购产品"
  },
  {
    path: "/apply/GoodsGroup/4/checkActivity",
    name: "买单项目"
  },
  {
    path: "/apply/GoodsGroup/4/groupClass",
    name: "团购分类"
  },
  {
    path: "/apply/GoodsGroup/4/groupOrder",
    name: "团购订单"
  },
  {
    path: "/apply/GoodsGroup/4/evaluateList",
    name: "评价管理"
  },
  {
    path: "/apply/GoodsGroup/4/verification",
    name: "验消管理"
  },

  {
    path: "/apply/GoodsGroup/4/rank",
    name: "排行榜设置"
  },
  {
    path: "/apply/GoodsGroup/4/parameter",
    name: "参数设置",
    children: [
      {
        path: "/apply/GoodsGroup/4/serviceSupport",
        name: "服务支持"
      },
      {
        path: "/apply/GoodsGroup/4/paySupport",
        name: "支付支持"
      }
    ]
  },
  {
    path: "/apply/GoodsGroup/4/labelManage",
    name: "标签管理",
    children: [
      {
        path: "/apply/GoodsGroup/4/shopLabel",
        name: "商品库标签"
      },
      {
        path: "/apply/GoodsGroup/4/userLabel",
        name: "用户端标签"
      }
    ]
  }
];
